import { ReactElement } from 'react'
import { DayPicker as ReactDayPicker, DayPickerSingleProps } from 'react-day-picker'
import { createGlobalStyle } from 'styled-components'
import 'react-day-picker/dist/style.css'

import { IDayPickerExtraProps } from './types'

const DayPickerGlobalStyle = createGlobalStyle`
  .rdp {
    color: #28265D;
    margin: 0!important;
  }

  .rdp-head_cell{
    color: #717171;
  }

  .rdp-months {
    justify-content: center;
  }

  .rdp-day:hover{
    background-color: #F4F0FF !important;
  }

  .rdp-day_disabled, .rdp-day_disabled:hover{
    background-color: transparent !important;
    color:#B0B0B0 !important;
  }

  .rdp-day_selected, .rdp-day_selected:hover {
    background-color: #A86EEB !important;
  }
`

const DayPicker = ({
  onChange,
  disabledDays,
  value,
  month,
  ...props
}: Omit<IDayPickerExtraProps, 'value'> & Omit<DayPickerSingleProps, 'mode'> & { value?: Date | '' }): ReactElement => {
  const currentYear = new Date().getFullYear()

  const handleDayClick = (day?: Date): void => {
    onChange(day)
  }

  const getMonth = (): Date | undefined => {
    if (props.defaultMonth) {
      return props.defaultMonth
    }
    if (value) {
      return new Date(value)
    }
    if (month) {
      return month
    }
  }

  return (
    <>
      <DayPickerGlobalStyle />
      <ReactDayPicker
        {...props}
        mode="single"
        onSelect={handleDayClick}
        selected={value as Date}
        defaultMonth={getMonth()}
        weekStartsOn={1}
        disabled={disabledDays}
        showOutsideDays
        captionLayout="dropdown"
        fromYear={currentYear - 20}
        toYear={currentYear + 40}
      />
    </>
  )
}

export { DayPicker }
